export default "__VITE_ASSET__CRCnAWay__"